import { FC, useEffect, useRef } from "react";
import { VideoModal, VideoPlayer } from "./style";

export interface VideoPreviewModalProps {
  open: boolean;
  src: string;
  ariaLabel?: string;
  onClose: () => void;
}

const VideoPreviewModal: FC<VideoPreviewModalProps> = ({
  open,
  src,
  ariaLabel,
  onClose,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!open) videoRef.current?.pause();
  }, [open]);

  const handleClose = () => {
    videoRef.current?.pause();
    onClose();
  };

  // 禁用缩放动画，避免 transform 让固定的关闭按钮相对视频定位。
  return (
    <VideoModal
      aria-label={ariaLabel}
      open={open}
      centered
      width={960}
      transitionName=""
      onCancel={handleClose}
      destroyOnClose
      footer={null}
    >
      <VideoPlayer
        key={src}
        ref={videoRef}
        src={src}
        aria-label={ariaLabel}
        controls
        controlsList="nodownload"
        playsInline
        preload="metadata"
      />
    </VideoModal>
  );
};

export default VideoPreviewModal;
